// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"7e9e08b9","201":"a27ffdc9","454":"89627bd2","585":"40ebbd65","956":"afcb6fa0"}[chunkId] + ".chunk.js";
};